import { StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { color, fontFamily } from '../../theme'

export const styles = StyleSheet.create({
  buttonStyle: {
    height: moderateScale(48),
    width: '100%',
    backgroundColor: color.primaryBlack,
    borderRadius: 48,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    opacity: 1
  },
  buttonView: {
    paddingHorizontal: 40,
    alignSelf: 'center',
    padding: 2
  },
  buttonText: {
    color: color.text,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  loadingStyle: {
    width: 20,
    height: 20,
    right: 0,
    position: 'absolute',
    top: 3
  }
})
